module.exports = __webpack_public_path__ + "images/61fd88dd812fa0b61aa497f8e4e58a92.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/woman/9.png
// module id = 385
// module chunks = 0